import m from "../../../../geodata/es2015/region/world/centralAmericaLow";
window.am4geodata_region_world_centralAmericaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/centralAmericaLow.js
// module id = null
// module chunks = 